
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Pimprichichwadtomumbaiacabservice() {



    const cardData =
    {
        keyword: 'Pimpri Chinchwad to Mumbai Cab Service',
        heading: 'Meghana Cab : Pimpri Chinchwad to Mumbai Cab Service',
        headingDescription: 'Meghana Cab offers Pimpri Chinchwad to Mumbai Cab Service, delivering safe, comfortable, and punctual travel solutions for individuals, families, and corporate clients. Whether you are traveling to Mumbai for work, leisure, or airport transfers, our wide fleet of Hatchbacks, Sedans, SUVs, and Tempo Travellers caters to every requirement. Enjoy doorstep pickup from Pimpri, Chinchwad, Akurdi, or Nigdi and reach Mumbai with ease. With trained drivers, clean vehicles, fixed pricing, and 24/7 support, Meghana Cab makes your journey smooth and worry-free. Book your Pimpri Chinchwad to Mumbai Cab today for a reliable and efficient travel experience.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [
    {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

"services": [
    {
        "name": "Pimpri to Mumbai Cab Booking",
        "description": "Book a cab from Pimpri to Mumbai for smooth, reliable intercity travel. Our service offers well-maintained vehicles, trained drivers, and flexible pick-up options from Pimpri's residential and commercial areas. Ideal for business, leisure, or emergency travel."
    },
    {
        "name": "Chinchwad to Mumbai Taxi",
        "description": "Travel from Chinchwad to Mumbai with ease using our dependable taxi service. We offer various car types, including sedans and SUVs, with options for both one-way and round trips. Perfect for solo travelers, families, and professionals."
    },
    {
        "name": "One Way Cab Pimpri Chinchwad to Mumbai",
        "description": "Save on costs with our one-way cab service from Pimpri-Chinchwad to Mumbai. No return fare required. Ideal for travelers catching a flight, visiting family, or relocating—enjoy a clean cab, verified driver, and direct drop-off."
    },
    {
        "name": "Round Trip Cab Pimpri Chinchwad to Mumbai",
        "description": "Planning to return the same day or within a few days? Our round trip cab from Pimpri-Chinchwad to Mumbai offers discounted pricing and driver waiting time. Great for business visits, day trips, or event travel."
    },
    {
        "name": "Online Taxi Pimpri Chinchwad to Mumbai",
        "description": "Book your Pimpri-Chinchwad to Mumbai taxi online through our easy-to-use platform. Choose from multiple car categories, view real-time pricing, and confirm your ride instantly—no phone calls needed."
    },
    {
        "name": "AC Cab Pimpri Chinchwad to Mumbai",
        "description": "Enjoy a cool, comfortable ride with our AC cabs from Pimpri-Chinchwad to Mumbai. Ideal for longer journeys, our air-conditioned taxis ensure a relaxed and enjoyable travel experience regardless of the weather."
    },
    {
        "name": "Budget Cab Pimpri Chinchwad to Mumbai",
        "description": "Looking for affordable travel options? Our budget cabs from Pimpri-Chinchwad to Mumbai are pocket-friendly yet reliable, offering clean vehicles and professional drivers for daily or occasional commuters."
    },
    {
        "name": "SUV Cab Hire Pimpri to Mumbai",
        "description": "Need more space and comfort? Hire an SUV cab from Pimpri to Mumbai for your group or family. Our SUVs are perfect for long rides with luggage, offering extra legroom and safety on highways."
    },
    {
        "name": "Sedan Taxi Chinchwad to Mumbai",
        "description": "Book a sleek and fuel-efficient sedan taxi from Chinchwad to Mumbai. Perfect for professionals or couples seeking a comfortable ride with extra boot space and smooth road performance."
    },
    {
        "name": "Family Trip Cab Pimpri Chinchwad to Mumbai",
        "description": "Traveling with family? Choose our family-friendly cab services from Pimpri-Chinchwad to Mumbai. Our vehicles are spacious, child-safe, and include courteous drivers trained for family trips."
    },
    {
        "name": "Chauffeur Driven Cab Pimpri to Mumbai",
        "description": "Opt for a chauffeur-driven cab from Pimpri to Mumbai for a premium, hands-free experience. Our professional drivers are punctual, courteous, and ensure a safe and pleasant journey throughout."
    },
    {
        "name": "Corporate Travel Cab Chinchwad to Mumbai",
        "description": "Streamline your business travel with our corporate cab service from Chinchwad to Mumbai. We offer on-time pickups, AC vehicles, and invoices for expense tracking—ideal for executives and company staff."
    },
    {
        "name": "Fast Cab Booking Pimpri Chinchwad to Mumbai",
        "description": "Need a quick ride? Our fast cab booking system from Pimpri-Chinchwad to Mumbai lets you confirm your trip in under a minute. We prioritize punctuality and immediate availability for last-minute plans."
    },
    {
        "name": "24/7 Cab Service Pimpri to Mumbai",
        "description": "Travel any time with our 24/7 cab service from Pimpri to Mumbai. Whether it's an early morning flight or a late-night emergency, we’re available round the clock with safe and dependable cabs."
    },
    {
        "name": "Affordable Taxi Pimpri Chinchwad to Mumbai",
        "description": "Book an affordable taxi from Pimpri-Chinchwad to Mumbai without compromising on comfort or safety. Our service is designed for regular commuters and families seeking high-quality travel at the best value."
    }
],
"tableData": [
    ["Pimpri to Mumbai Cab Booking", "Chinchwad to Mumbai Taxi"],
    ["One Way Cab Pimpri Chinchwad to Mumbai", "Round Trip Cab Pimpri Chinchwad to Mumbai"],
    ["Online Taxi Pimpri Chinchwad to Mumbai", "AC Cab Pimpri Chinchwad to Mumbai"],
    ["Budget Cab Pimpri Chinchwad to Mumbai", "SUV Cab Hire Pimpri to Mumbai"],
    ["Sedan Taxi Chinchwad to Mumbai", "Family Trip Cab Pimpri Chinchwad to Mumbai"],
    ["Chauffeur Driven Cab Pimpri to Mumbai", "Corporate Travel Cab Chinchwad to Mumbai"],
    ["Fast Cab Booking Pimpri Chinchwad to Mumbai", "24/7 Cab Service Pimpri to Mumbai"],
    ["Affordable Taxi Pimpri Chinchwad to Mumbai", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Convenient Cab Service from Pimpri Chinchwad to Mumbai",
        "WhyChoosedescription": "Our Pimpri Chinchwad to Mumbai cab service offers hassle-free travel with easy booking options and timely pickups. Whether it’s for business, leisure, or airport transfers, we ensure a smooth and comfortable journey every time."
    },
    {
        "WhyChooseheading": "Wide Range of Well-Maintained Vehicles",
        "WhyChoosedescription": "Choose from a variety of vehicles including sedans, SUVs, and luxury cars. All our vehicles are regularly serviced and cleaned, equipped with air-conditioning and spacious interiors to provide a comfortable travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our drivers are professionally trained, courteous, and well-versed with the best routes between Pimpri Chinchwad and Mumbai. They prioritize your safety and ensure a timely and smooth ride throughout the journey."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "We provide clear and affordable pricing with no hidden fees. Our fare includes tolls, driver allowance, taxes, and fuel, so you can travel worry-free knowing exactly what you’ll pay upfront."
    },
    {
        "WhyChooseheading": "Flexible Booking and Customized Travel Plans",
        "WhyChoosedescription": "Book your cab for one-way or round trips, hourly rentals, or special occasions. Customize your pickup and drop locations, travel times, and route preferences to suit your specific needs."
    },
    {
        "WhyChooseheading": "Doorstep Pickup and Drop-off",
        "WhyChoosedescription": "Experience the convenience of doorstep service. We pick you up from any location in Pimpri Chinchwad and drop you off directly at your destination in Mumbai, saving you time and effort."
    },
    {
        "WhyChooseheading": "Ideal for Corporate, Family, and Airport Transfers",
        "WhyChoosedescription": "Our cab service is perfect for business travelers, families, and those needing reliable airport transfers. Travel comfortably and on schedule with our dedicated and customer-focused service."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Emergency Assistance",
        "WhyChoosedescription": "Our customer support team is available round-the-clock to help with bookings, changes, or any concerns during your trip. We also provide emergency assistance for any unforeseen issues on the road."
    }
]



















    }

const faqData = [
    {
        question: "How do I book a cab from Pimpri Chinchwad to Mumbai?",
        answer: "You can book a cab by calling Meghana Cab at +91 9075462128 or through our website for quick and reliable service."
    },
    {
        question: "What is the approximate travel time from Pimpri Chinchwad to Mumbai by cab?",
        answer: "The travel time is typically around 3 to 4 hours, depending on traffic and weather conditions."
    },
    {
        question: "Are one way and round trip options available from Pimpri Chinchwad to Mumbai?",
        answer: "Yes, we offer both one way and round trip cab services to suit your travel needs."
    },
    {
        question: "What types of vehicles are available for this route?",
        answer: "We provide hatchbacks, sedans, SUVs, and tempo travellers based on the number of passengers and luggage requirements."
    },
    {
        question: "Is the cab service available 24/7 from Pimpri Chinchwad to Mumbai?",
        answer: "Yes, Meghana Cab operates round the clock for your convenience and urgent travel needs."
    },
    {
        question: "Are your drivers experienced for long-distance routes like Pimpri Chinchwad to Mumbai?",
        answer: "Yes, our drivers are highly experienced and well-versed with the route to ensure a safe and timely journey."
    },
    {
        question: "What is included in the fare for this route?",
        answer: "The fare includes fuel, tolls, and driver charges. Additional parking or waiting fees, if any, are extra."
    },
    {
        question: "Can I book a cab at the last minute from Pimpri Chinchwad to Mumbai?",
        answer: "Yes, last-minute bookings are possible, subject to vehicle availability. It's best to call us directly for urgent travel."
    },
    {
        question: "Is online booking available for Pimpri Chinchwad to Mumbai cab?",
        answer: "Yes, you can book online 24/7 via our website with instant confirmation and secure payment options."
    },
    {
        question: "Can I request stops during the journey for food or rest?",
        answer: "Yes, you can request stops along the way. Please inform the driver in advance or while booking."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Nilesh Jadhav',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked a cab from Pimpri Chinchwad to Mumbai for a business meeting. The service was punctual, and the ride was smooth.”',
    },
    {
        name: 'Ms. Ashwini Kadam',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab made our family trip from Pimpri Chinchwad to Mumbai stress-free. Great driver and very clean vehicle.”',
    },
];


















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pimpri Chinchwad to Mumbai Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/pimpri-chinchwad-to-mumbai-cab.jpg",
  "description": "Book a cab from Pimpri Chinchwad to Mumbai with Meghana Cabs. Choose from AC Sedans, SUVs, and chauffeur-driven options. Affordable fares, round trip or one-way service, and 24/7 online booking available.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1899",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pimpri-chinchwad-to-mumbai-cab-service"
  }
};








    return (
        <div>

<Helmet>
  <title>Pimpri Chinchwad to Mumbai Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book a reliable cab from Pimpri Chinchwad to Mumbai with Meghana Cabs. Affordable one-way and round trip fares. AC Sedans, SUVs, and chauffeur-driven vehicles available with 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Pimpri to Mumbai Cab Booking, Chinchwad to Mumbai Taxi, One Way Cab Pimpri Chinchwad to Mumbai, Round Trip Cab Pimpri Chinchwad to Mumbai, Online Taxi Pimpri Chinchwad to Mumbai, AC Cab Pimpri Chinchwad to Mumbai, Budget Cab Pimpri Chinchwad to Mumbai, SUV Cab Hire Pimpri to Mumbai, Sedan Taxi Chinchwad to Mumbai, Family Trip Cab Pimpri Chinchwad to Mumbai, Chauffeur Driven Cab Pimpri to Mumbai, Corporate Travel Cab Chinchwad to Mumbai, Fast Cab Booking Pimpri Chinchwad to Mumbai, 24/7 Cab Service Pimpri to Mumbai, Affordable Taxi Pimpri Chinchwad to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/75.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Pimprichichwadtomumbaiacabservice;